export enum PdfPreviewParamNames {
    Notes ="Note",
    TravelLeg ="Travel",
    attachments = "attachments"
}